import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { TranslateDirective } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { Store } from '@ngrx/store';
import { setChartShowThresholdColor } from '@app/main/main-screen/store/main-selection/main-shared-selection/main-shared-selection.actions';
import { selectChartShowThresholdColor } from '@app/main/main-screen/store/main-selection/main-shared-selection/main-shared-selection.selectors';
import { ColorManagementService } from '@app/core/services/colors/color-management.service';
import { MetricColorType } from '@app/core/enums/metric-color-type.enum';
import { ScreenResolutionService } from '@app/core/services/screen-resolution/screen-resolution.service';

@Component({
  selector: 'gc-floating-popup-chart-threshold-color-action',
  standalone: true,
  imports: [ReactiveFormsModule, ToggleSwitch, TranslateDirective],
  templateUrl: './floating-popup-chart-threshold-color-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingPopupChartThresholdColorActionComponent implements OnInit {
  public readonly scrRes = inject(ScreenResolutionService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly store = inject(Store);
  private readonly colorManagementService = inject(ColorManagementService);

  public isLabelHidden = input<boolean>(false);

  public readonly warningColor = this.colorManagementService
    .getChartThresholdColorInstance(MetricColorType.Warning)
    .toRgbString();
  public readonly positiveColor = this.colorManagementService
    .getChartThresholdColorInstance(MetricColorType.Positive)
    .toRgbString();
  public readonly criticalColor = this.colorManagementService
    .getChartThresholdColorInstance(MetricColorType.Critical)
    .toRgbString();

  public readonly formGroup = new FormGroup({
    thresholdColor: new FormControl<boolean>(false, { nonNullable: true }),
  });

  ngOnInit(): void {
    this.store
      .select(selectChartShowThresholdColor)
      .pipe(
        map(value => !!value),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(value => {
        this.formGroup.controls.thresholdColor.setValue(value, { emitEvent: false });
      });

    this.formGroup.controls.thresholdColor.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
      this.store.dispatch(setChartShowThresholdColor({ chartShowThresholdColor: value }));
    });
  }
}
